import { EventTypes, track, PageSource } from '@mc/track-event'

export type PageSourceType =
  | typeof PageSource.CLASS_PAGE
  | typeof PageSource.EPISODE_PAGE
  | typeof PageSource.OUTCOME

const clickEventNamesByPageSource = {
  [PageSource.CLASS_PAGE]: EventTypes.COURSE_MARKETING_CLICK,
  [PageSource.EPISODE_PAGE]: EventTypes.EPISODE_PAGE_CLICK,
  [PageSource.OUTCOME]: EventTypes.OUTCOME_PAGE_CLICK,
}

const viewEventNamesByPageSource = {
  [PageSource.CLASS_PAGE]: EventTypes.COURSE_MARKETING_PAGE_ROW_VIEWED,
  [PageSource.EPISODE_PAGE]: EventTypes.EPISODE_PAGE_ROW_VIEWED,
  [PageSource.OUTCOME]: EventTypes.OUTCOME_PAGE_ROW_VIEWED,
}

export const trackSubcatSeeAllClick = (
  subcategoryName: string,
  primaryCategoryName: string,
  row: number,
  pageSource: PageSourceType,
) => {
  track(clickEventNamesByPageSource[pageSource], {
    category: 'explore-class-catalog',
    location: `sub_category_carousel:${subcategoryName}`,
    action: 'See All',
    row_position: row,
    subcategory_name: subcategoryName,
    category_name: primaryCategoryName,
  })
}

export const trackSubcatCarouselViewed = (
  subcategoryName: string,
  primaryCategoryName: string,
  row: number,
  pageSource: PageSourceType,
) => {
  track(viewEventNamesByPageSource[pageSource], {
    category: 'explore-class-catalog',
    row_name: `sub_category_carousel:${subcategoryName}`,
    row_position: row,
    category_name: primaryCategoryName,
  })
}
